module.exports = __webpack_public_path__ + "img/angle_right.c28b7e7e.svg";